import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getUsersById } from 'auth/store/users/selectors';
import LargeLabel from 'base/components/LargeLabel';
import SmallLabel from 'base/components/SmallLabel';
import MimeTypeIcon from 'documents/components/MimeTypeIcon/MimeTypeIcon';
import theme from 'theme/theme';
import Date from 'base/components/Date';
import AuthorLabel from 'base/components/AuthorLabel';
import { getSpacesById } from 'spaces/store/selectors';
import {
  navigateToDocument,
} from 'documents/store/documents/actions';
import {
  navigateToFolder,
} from 'documents/store/folders/actions';
import {
  getBreadcrumbPathsForDocumentId,
} from 'documents/store/documents/selectors';
import {
  getBreadcrumbPathsForFolderId,
} from 'documents/store/folders/selectors';
import Breadcrumb from 'base/components/Breadcrumb';
import { FolderIcon, ArrowForwardIcon } from 'base/components/Icon';
import Teaser from 'base/components/Teaser';

const DocumentLabel = styled(LargeLabel)`
  overflow-x: hidden;
  overflow-y: visible;
  text-overflow: ellipsis;
`;

const SpaceLabel = styled(SmallLabel)`
  color: ${theme.colors.darker};
  line-height: 1rem;
`;


class FileExplorerTeaser extends React.Component {
  componentDidMount() {
  }


  render() {
    const {
      entity,
      spaceId,
      actions,
      usersById,
      spacesById,
      documentBreadcrumbPaths,
      folderBreadcrumbPaths,
      navigateToDocument,
      navigateToFolder,
    } = this.props;

    const paths = entity.entityType === 'document'
      ? documentBreadcrumbPaths
      : folderBreadcrumbPaths;

    const documentActions = [
      {
        icon: ArrowForwardIcon,
        onClick: navigateToDocument,
        key: 'primary',
      },
    ];
    const folderActions = [
      {
        icon: ArrowForwardIcon,
        onClick: navigateToFolder,
        key: 'primary',
      },
    ];

    const defaultActions = entity.entityType === 'folder' ? folderActions : documentActions;


    return (
      <Teaser actions={actions || defaultActions} item={entity}>

        <Teaser.IconCol>
          <div>
            {(entity.entityType === 'document')
              ? (<MimeTypeIcon mimeType={entity.file && entity.file.mime} />)
              : (<FolderIcon color={theme.colors.medium} size="23px" />)}
          </div>
        </Teaser.IconCol>

        <Teaser.MainCol>
          {spaceId === null && (
            <SpaceLabel>
              {spacesById[entity.space] && spacesById[entity.space].name}
            </SpaceLabel>
          )}

          {paths && (<Breadcrumb paths={paths} />)}

          <DocumentLabel isPrimary>
            {entity.name}
          </DocumentLabel>

          <Teaser.MetaWrapper>
            <Teaser.Meta>
              <AuthorLabel
                name={usersById[entity.createdBy] && usersById[entity.createdBy].fullName}
              />
            </Teaser.Meta>
            <Teaser.Meta>
              <Date date={entity.lastModifiedAt} />
            </Teaser.Meta>
          </Teaser.MetaWrapper>
        </Teaser.MainCol>

      </Teaser>
    );
  }
}
FileExplorerTeaser.propTypes = {
  usersById: PropTypes.objectOf(PropTypes.any).isRequired,
  spacesById: PropTypes.objectOf(PropTypes.any).isRequired,
  spaceId: PropTypes.number,
  actions: PropTypes.arrayOf(PropTypes.object),
  entity: PropTypes.objectOf(PropTypes.any).isRequired,
  folderBreadcrumbPaths: PropTypes.arrayOf(PropTypes.any),
  documentBreadcrumbPaths: PropTypes.arrayOf(PropTypes.any),
  navigateToDocument: PropTypes.func.isRequired,
  navigateToFolder: PropTypes.func.isRequired,
};
FileExplorerTeaser.defaultProps = {
  spaceId: null,
  actions: undefined,
  folderBreadcrumbPaths: null,
  documentBreadcrumbPaths: null,
};

const mapStateToProps = (state, props) => ({
  usersById: getUsersById(state),
  spacesById: getSpacesById(state),
  folderBreadcrumbPaths: getBreadcrumbPathsForFolderId(state, props.entity.id),
  documentBreadcrumbPaths: getBreadcrumbPathsForDocumentId(state, props.entity.id),
});
const mapDispatchToProps = {
  navigateToDocument,
  navigateToFolder,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FileExplorerTeaser);
